import { render } from "./OneNews.vue?vue&type=template&id=428a3c0c&scoped=true"
import script from "./OneNews.vue?vue&type=script&lang=js"
export * from "./OneNews.vue?vue&type=script&lang=js"

import "./OneNews.vue?vue&type=style&index=0&id=428a3c0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428a3c0c"]])

export default __exports__